var map = {
	"./czosnow/kontakt_pl.mdx": [
		5229,
		7610
	],
	"./mielno/kontakt_pl.mdx": [
		1875,
		1875
	],
	"./nowa-karczma/kontakt_pl.mdx": [
		4380,
		4380
	],
	"./ostroleka/kontakt_pl.mdx": [
		6517,
		6517
	],
	"./przemysl/kontakt_pl.mdx": [
		9957,
		9957
	],
	"./slubice/kontakt_pl.mdx": [
		3972,
		3972
	],
	"./sopot/kontakt_pl.mdx": [
		6490,
		6490
	],
	"./szczecin/kontakt_pl.mdx": [
		7824,
		7824
	],
	"./torun/kontakt_pl.mdx": [
		5381,
		5381
	],
	"./warlubie/kontakt_pl.mdx": [
		3948,
		3948
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3160;
module.exports = webpackAsyncContext;